import { AdductionOrder } from '@features/siteStatusV2/types';
import React from 'react';

import OrderDetails from '../order-details';
import { createAdductionDisplayConfig } from './helpers';

interface AdductionOrderDetailsProps {
  order: AdductionOrder;
}

const AdductionOrderDetails: React.FC<AdductionOrderDetailsProps> = ({ order }) => {
  const adductionDisplayConfig = createAdductionDisplayConfig(order);
  return (
    <OrderDetails
      header={adductionDisplayConfig.header}
      sections={adductionDisplayConfig.sections}
    />
  );
};

export default AdductionOrderDetails;
